<template>
	<div class="text-box" :class="visible ? 'transition-height transition-delay-'+delay : 'transition-no-height'">
		<div class="text-box-continer">
			<p v-if="text1"><b v-if="key1">{{ key1 }}.</b> {{ text1 }}</p>
			<p v-if="text2"><b v-if="key2">{{ key2 }}.</b> {{ text2 }}</p>
			<p v-if="text3"><b v-if="key3">{{ key3 }}.</b> {{ text3 }}</p>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
	    visible: {
        default: () => false
	    },
	    delay: {
        default: () => 0
	    },
	    key1: {
        default: () => false
	    },
	    key2: {
        default: () => false
	    },
	    key3: {
        default: () => false
	    },
	    text1: {
        default: () => false
	    },
	    text2: {
        default: () => false
	    },
	    text3: {
        default: () => false
	    }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/TextBox.vue